import { SVGS } from 'app/constants/SVGS';
import { TOOLTIPS } from 'app/constants/TOOLTIPS';
import { AppInjector } from 'app/services/app-injector.service';
import { DeveloperStateService } from 'app/states/developer-state.service';

export abstract class DeveloperInsightSectionComponent {
  public SVGS = SVGS;
  public TOOLTIPS = TOOLTIPS;

  protected _developerStateService: DeveloperStateService;

  constructor() {
    this._developerStateService = AppInjector.injector.get(
      DeveloperStateService
    );
  }
}
